@if (isEpcotTemplate) {
    @if (visible$ | async) {
        <div class="content-message-container odds-preference-container">
            <div class="content-message info">
                <vn-icon class="odds-preference-info-icon" name="theme-info-i" size="16" />
                <span class="ui-icon odds-preference-icon"></span>
                <div class="page-matrix">
                    <div class="pc-text pc-component">
                        <span class="betslip-notification-title">
                            {{ sitecore.betslip.messages.WantFasterBetting }}
                        </span>
                    </div>
                    <div class="odds-preference-body">
                        <span class="odds-preference-body-text">
                            {{ sitecore.betslip.messages.AlwaysAcceptAllOdds }}
                        </span>
                        <ds-switch class="switch-box" variant="utility" [checked]="enabled" (checkedChange)="onValueChange($event)" />
                    </div>
                </div>
            </div>
        </div>
    }
} @else {
    @if (visible$ | async) {
        <a class="linkbox betslip-error-oddsaction add-header slide-in">
            <vn-icon class="oddsaction-chronometer-icon" name="theme-chronometer" size="26" />
            <div class="odds-action-text">
                <h4>{{ sitecore.betslip.messages.WantFasterBetting }}</h4>
                <div>{{ sitecore.betslip.messages.AlwaysAcceptAllOdds }}</div>
            </div>
            <ds-switch
                msThemedSwitch
                [themedVariant]="variant"
                [themeInverse]="themeInverseIndicator"
                [checked]="enabled"
                (checkedChange)="onValueChange($event)" />
        </a>
    }
}
